import React, { useContext, useEffect } from 'react'
import { Col, Form } from 'react-bootstrap'
import FilterContext from '../../contexts/FilterContext'
import { COLORS } from '../../constants/colors'

function FilterByStatus() {
    const { selectedStatus, setSelectedStatus } = useContext(FilterContext);

    // Define colors
    const plum = COLORS.PLUM;
    const warmConcrete = COLORS.WARM_CONCRETE;

    // Define all available statuses including UPCOMING (3)
    const statuses = [
        { name: 'ALL', value: 'all', id: 's-0' },
        { name: 'LIVE', value: '1', id: 's-1' },
        { name: 'UPCOMING', value: '3', id: 's-3' },
        { name: 'ENDED', value: '2', id: 's-2' }
    ];

    // Set default status to LIVE (1) if none is selected
    useEffect(() => {
        if (!selectedStatus) {
            setSelectedStatus('1');
        }
    }, [selectedStatus, setSelectedStatus]);

    const handleStatusChange = (statusValue) => {
        setSelectedStatus(statusValue);
    };

    // Custom styles for the status filter options
    const labelStyle = {
        display: 'block',
        padding: '2px',
        margin: '2px 0',
        backgroundColor: warmConcrete,
        color: plum,
        borderRadius: '2px',
        cursor: 'pointer',
        border: `1px solid ${plum}`,
        transition: 'all 0.2s ease'
    };

    const checkedLabelStyle = {
        ...labelStyle,
        backgroundColor: plum,
        color: warmConcrete,
        fontWeight: 'bold'
    };

    return (
        <>
            <Col className="text-center border-top border-bottom py-2 fw-bold">
                Filter by Status
            </Col>
            <Col className='ms-xl-3' style={{ fontSize: 'smaller' }}>
                <Form>
                    {statuses.map((status) => (
                        <Col key={status.id} className='my-2'>
                            <div 
                                style={selectedStatus === status.value ? checkedLabelStyle : labelStyle}
                                onClick={() => handleStatusChange(status.value)}
                            >
                                <Form.Check
                                    type='radio'
                                    id={status.id}
                                    value={status.value}
                                    label={status.name}
                                    name='statusGroup'
                                    onChange={() => handleStatusChange(status.value)}
                                    checked={selectedStatus === status.value}
                                    style={{ marginBottom: 0 }}
                                />
                            </div>
                        </Col>
                    ))}
                </Form>
            </Col>
        </>
    )
}

export default FilterByStatus
